export default "__VITE_ASSET__23145604__"